<div class="container container_type_main">
  <div class="subtitle h2 mt-32">{{ 'subscriber-rules-page.title' | translate }}</div>
<!--  <div class="info-hint">Чтобы добавить контакт в правила звучания, установите хотя бы один трек</div>-->

  <div class="page-tabs__container">
    <div class="page-tabs">
      <div class="page-tabs__item" [class.page-tabs__item-active]="activeTab == Tab.CONTACTS" (click)="showContacts()">
        <div class="page-tabs__link">{{ 'subscriber-rules-page.contacts' | translate }}</div>
      </div>
      <div class="page-tabs__item" [class.page-tabs__item-active]="activeTab == Tab.GROUPS" (click)="showGroups()">
        <div class="page-tabs__link">{{ 'subscriber-rules-page.groups' | translate }}</div>
      </div>
    </div>
  </div>

  <ng-container *ngIf="activeTab == Tab.CONTACTS">
    <ng-container [ngTemplateOutlet]="contactsList" *ngIf="contacts?.length > 0 else listEmpty"></ng-container>
  </ng-container>

  <ng-container *ngIf="activeTab == Tab.GROUPS">
    <ng-container [ngTemplateOutlet]="groupsList" *ngIf="groups?.length > 0 else listEmpty"></ng-container>
  </ng-container>

  <app-mobile-apps-banner></app-mobile-apps-banner>
</div>

<ng-template #contactsList>
  <div class="rules-list">
    <div class="songs-list">
      <div class="songs-list__item" *ngFor="let contact of contacts" app-contact-item [contact]="contact" [showControls]="true"></div>
    </div>
    <span class="button" (click)="addContact()" [class.button_status_disabled]="!privetActive">{{ 'subscriber-rules-page.add-contact' | translate }}</span>
  </div>
</ng-template>

<ng-template #groupsList>
  <div class="rules-list">
    <div class="songs-list">
      <div class="songs-list__item" *ngFor="let group of groups" app-group-item [group]="group" [showControls]="true"></div>
    </div>
    <span class="button" (click)="addGroup()" [class.button_status_disabled]="!(privetActive && contacts?.length > 0)">{{ 'subscriber-rules-page.add-group' | translate }}</span>
  </div>
</ng-template>

<ng-template #listEmpty>
  <div class="page-notfound">
    <div class="page-notfound__img"></div>
    <div class="page-notfound__name h2">{{ 'subscriber-rules-page.rules-empty' | translate }}</div>
    <div class="page-notfound__text" *ngIf="activeTab == Tab.CONTACTS" >{{ 'subscriber-rules-page.create-contact-hint' | translate }}</div>
    <div class="page-notfound__text" *ngIf="activeTab == Tab.GROUPS" >{{ 'subscriber-rules-page.create-rule-hint' | translate }}</div>
    <div class="page-notfound__button">
      <span class="button" [class.button_status_disabled]="!privetActive" *ngIf="activeTab == Tab.CONTACTS" (click)="addContact()">{{ 'subscriber-rules-page.add-contact' | translate }}</span>
      <span class="button" [class.button_status_disabled]="!(privetActive && contacts?.length > 0)" *ngIf="activeTab == Tab.GROUPS" (click)="addGroup()">{{ 'subscriber-rules-page.add-group' | translate }}</span>
    </div>
  </div>
</ng-template>
